module.exports = __webpack_public_path__ + "assets/553f8b0960438774b2bfa551aad4ec70.mp3";